export class TranslatedError extends Error {
    title: string | null;
    action: string | null;
    constructor(errorMessage: string) {
        super(errorMessage);
    }
}